import { useMutation } from '@tanstack/react-query'
import { withIdempotency } from '@/hooks/withIdempotency'
import { submitFeedback, type FeedbackPayload } from '@/services/api/feedback'

export function useSubmitFeedback() {
  type Vars = FeedbackPayload & { idempotencyKey?: string }
  const mutation = useMutation({
    mutationFn: ({ idempotencyKey, ...data }: Vars) => submitFeedback(data, idempotencyKey),
  })
  return withIdempotency(mutation)
}
